import { Component } from '@angular/core';
import { ColumnDateDto } from 'webcommon/shared';
import { ApColumnBase } from './ap-column-base';

@Component({
  selector: 'ap-column-date-time',
  templateUrl: './ap-column-date-time.component.html',
})
export class ApColumnDateTimeComponent extends ApColumnBase<ColumnDateDto> {
  displayDate: string;
  dateFormat: string;

  load() {
    this.displayDate = this.columnInfoDto?.DateStringCallback?.(this.dataItem) ?? '';
    this.dateFormat = this.columnInfoDto?.DateFormat ?? 'MM/dd/yyyy h:mm a';
  }
}
